<template>
  <div class="container">
    <div class="content">
      <div class="top">
        <div class="title">超级菜谱</div>
        <div class="more" @click="bindMore">更多超级菜谱</div>
      </div>
      <div class="menu-list">
        <div
          class="menu-item"
          v-for="(item, index) in data"
          :key="index"
          @click="bindJumpRecipe(index)"
        >
          <img class="item-pic" :src="item.icon" alt="" />
          <div class="item-right">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-desc">{{ item.desc }}</div>
            <div class="item-diff">
              <div>
                <span class="text">难度</span>
                <van-rate
                  class="star"
                  v-model="item.difficulty_degree"
                  :gutter="0"
                  :size="12"
                  color="#FFAF49"
                  void-icon="star"
                  void-color="#D8D8D8"
                />
              </div>
              <div>用时{{ item.make_stime }}-{{ item.make_etime }}分钟</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      starNum: 3
    }
  },
  methods: {
    bindJumpRecipe(index) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/recipeDetails?id=' + this.data[index].id
        )
      } else {
        this.$toast('请前往APP打开')
      }
    },
    bindMore() {
      if (this.$http._isApp()) {
        this.$betterwe.checkAppUpdate(38)
        this.$betterwe.onAppPageUrlRoute('/recipeHome')
      } else {
        this.$toast('请前往APP打开')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 343px;
  margin: 0 auto;
  margin-bottom: 16px;
  background: #ffffff;
  border-radius: 10px;
  padding: 14px 16px 20px;
  box-sizing: border-box;
  .top {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 21px;
    }
    .more {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      line-height: 17px;
    }
  }
  .menu-list {
    .menu-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .item-pic {
        width: 112px;
        height: 112px;
        object-fit: cover;
        margin-right: 10px;
        border-radius: 8px;
      }
      .item-right {
        flex: 1;
        flex-shrink: 0;
        .item-name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 24px;
          margin-bottom: 3px;
        }
        .item-desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.7);
          line-height: 19px;
          margin-bottom: 19px;
        }
        .item-diff {
          display: flex;
          align-items: center;
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #aeaeae;
          line-height: 14px;
          .text {
            margin-right: 5px;
          }
          .star {
            margin-right: 12px;
          }
        }
      }
    }
    .menu-item:last-child {
      border-bottom: 0px;
    }
  }
}
</style>
